import React, { useState, useEffect } from 'react';
import {
  Typography,
  Container,
  Box,
  Button,
  Grid,
  Card,
  Stack,
  Link
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LandingPageLayoutMobile from '../../layout/LandingPageLayoutMobile';
import { Check } from '@mui/icons-material';
import tipoContrattoApi from '../../api/tipocontrattoApi';
import logoImg from '../../assets/logo.png';

export default function DeskStudioLandingPageMobile() {
  const navigate = useNavigate();
  const [tipiContratto, setTipiContratto] = useState([]);

  const handleRegisterFromPlan = (profile, tipoContrattoId) => {
    const params = new URLSearchParams({
      profile,
      tipoContrattoId: tipoContrattoId ?? ''
    });
    navigate(`/register?${params.toString()}`);
  };

  useEffect(() => {
    async function fetchTipi() {
      try {
        const res = await tipoContrattoApi.getAllPublic();
        setTipiContratto(res.data.filter(t => t.attivo && t.tipo !== 'BASIC'));
      } catch (e) {
        console.error(e);
      }
    }
    fetchTipi();
  }, []);

  if (!tipiContratto) return null;

  return (
    <LandingPageLayoutMobile>

      {/* HERO */}
      <Box
        id="hero"
        sx={{
          py: 10,
          textAlign: 'center',
          px: 2
        }}
      >
        <img src={logoImg} alt="DeskStudio" style={{ maxWidth: 100, marginBottom: 16 }} />

        <Typography variant="h4" sx={{ fontWeight: 800, mb: 2 }}>
          DeskStudio
        </Typography>

          <Typography variant="h5" sx={{ mb: 3, color: '#555' }}>
            Evita errori fiscali e risparmia ore ogni settimana
          </Typography>

          <Typography variant="body1" sx={{ mb: 4, color: '#777' }}>
            Automatizza scadenze, fatture , documenti e pagamenti in un unico sistema.
          </Typography>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
            <Button variant="outlined" size="large" onClick={() => navigate('/register')}>
              Prova gratis
            </Button>
            <Button variant="outlined" size="large" onClick={() => navigate('/login')}>
              Accedi
            </Button>

          </Stack>

        {/* LINK POLICY (MIGLIORATI PER MOBILE) */}
        <Stack spacing={1} sx={{ mt: 3 }}>
            <Typography sx={{ mt: 2, color: '#666' }}>
              Nessuna carta di credito • Attivazione in 2 minuti
            </Typography>
                     {/* DEMO */}
                     <Box sx={{ mt: 6 }}>
                       <img src="/demo-dashboard.png" alt="Demo DeskStudio" style={{ width: '100%', maxWidth: 900, borderRadius: 12 }} />
                     </Box>
          <Button size="small" onClick={() => navigate('/privacy')}>Privacy</Button>
          <Button size="small" onClick={() => navigate('/terms')}>Termini e Condizioni</Button>
          <Button size="small" onClick={() => navigate('/cookie')}>Cookie Policy</Button>
        </Stack>

        {/* CTA CROWDFUNDING */}
        {/*<Box sx={{ mt: 4 }}>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Aiutaci a sviluppare il progetto. Iscriviti alla mailing list.
            Chi si iscrive avrà vantaggi e sconti sulla piattaforma DeskStudio
          </Typography>

          <Button fullWidth variant="text" onClick={() => navigate('/sitopubblico/crowdfunding')}>
            Scopri il progetto
          </Button>
        </Box>*/}
      </Box>

      {/* PROBLEMA */}
      <Container id="problema" sx={{ py: 6 }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
          Le scadenze non dovrebbero essere un problema
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center', color: '#666' }}>
          Tra documenti sparsi, controlli manuali e scadenze dimenticate, la gestione fiscale diventa un rischio.
        </Typography>
        <Typography variant="h6" sx={{ textAlign: 'center', color: '#666' }}>
          <Button variant="outlined" onClick={() => document.getElementById('contatti').scrollIntoView()}> Richiedi informazioni</Button>
         </Typography>
      </Container>

      {/* SOLUZIONI */}
      <Box id="soluzioni" sx={{ py: 6, bgcolor: '#f8fafc' }}>
        <Container>
          <Typography variant="h5" sx={{ mb: 4, fontWeight: 700 }}>
            Tutto quello che ti serve
          </Typography>

          <Stack spacing={2}>
            {[
            { title: 'Documenti centralizzati', desc: 'Archivia e consulta tutte le fatture e i documenti in un unico spazio sicuro.' },
            { title: 'Scadenze automatiche', desc: 'Il sistema genera automaticamente le scadenze evitando dimenticanze.' },
             { title: 'Accesso clienti', desc: 'Condividi documenti e scadenze con i tuoi clienti in modo semplice.' },
             { title: 'Pagamenti tracciati', desc: 'Controlla lo stato dei pagamenti in tempo reale.' },
             { title: 'Notifiche intelligenti', desc: 'Ricevi alert automatici prima delle scadenze importanti.' },
             { title: 'Sicurezza avanzata', desc: 'I tuoi dati sono protetti con standard elevati.' } ].map((f, i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <Card sx={{ p: 3, borderRadius: 4 }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Check color="primary" />
                    <Typography fontWeight={600}>{f.title}</Typography>
                  </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography fontWeight={400}>{f.desc}</Typography>
                    </Stack>
                </Card>
              </Grid>
            ))}
          </Stack>
        </Container>
      </Box>

      {/* TESTIMONIANZE */}
      <Container id="testimonianze" sx={{ py: 6 }}>
        <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
          Cosa dicono i clienti
        </Typography>

        <Stack spacing={2}>
          {[
            '“Risparmio ore ogni settimana grazie alla automazione.”',
            '“Finalmente ho il controllo completo delle scadenze”'
          ].map((t, i) => (
            <Card key={i} sx={{ p: 3 }}>
              <Typography variant="body2">{t}</Typography>
            </Card>
          ))}
        </Stack>
      </Container>

      {/* PREZZI */}
      <Box id="prezzi" sx={{ py: 6, bgcolor: '#f8fafc' }}>
        <Container>
          <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
            Prezzi
          </Typography>

          <Typography variant="body2" sx={{ mb: 4 }}>
          Scegli il piano più adatto a te e semplifica la gestione fiscale.
          </Typography>

          <Stack spacing={2}>
            {[
              { plan: 'Base', price: '129€/anno', desc: '1 contribuente', profile: 'CONTRIBUENTE', tipoContrattoId: null },
              { plan: 'Studio 10', price: '349€/anno', desc: 'Fino a 10 contribuenti', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo === 'PACCHETTO10')?.id },
              { plan: 'Studio 20', price: '549€/anno', desc: 'Fino a 20 contribuenti', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo === 'PACCHETTO20')?.id },
              { plan: 'Studio 50', price: '899€/anno', desc: 'Fino a 50 contribuenti', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo === 'PACCHETTO50')?.id },
              { plan: 'Studio 150', price: '1799€/anno', desc: 'Fino a 150 contribuenti', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo === 'PACCHETTO150')?.id },
              { plan: 'Studio Plus', price: '2799€/anno', desc: 'Illimitati', profile: 'STUDIO', tipoContrattoId: tipiContratto.find(t => t.tipo == 'FULL')?.id },
            ].map((p, i) => (
              <Card key={i} sx={{ p: 3 }}>
                <Typography variant="h6">{p.plan} ({p.profile==='STUDIO'?'Commercialista':'Partita IVA'})</Typography>

                <Typography variant="h5" sx={{ fontWeight: 700, my: 1 }}>
                  {p.price}
                </Typography>

                <Typography variant="body2" sx={{ mb: 2 }}>
                  {p.desc}
                </Typography>

                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleRegisterFromPlan(p.profile, p.tipoContrattoId)}
                >
                  Scegli
                </Button>
              </Card>
            ))}
          </Stack>
        </Container>
      </Box>

      {/* CONTATTI */}
      <Container id="contatti" sx={{ py: 6 }}>
        <Typography variant="h5" sx={{ textAlign: 'center' }}>
          Contattaci
        </Typography>

        <Typography sx={{ textAlign: 'center', mt: 2 }}>
          <Link href="mailto:info@deskstudio.it">
            info@deskstudio.it
          </Link>
        </Typography>
      </Container>

      {/* FOOTER */}
      <Box sx={{ bgcolor: '#111', color: '#fff', py: 3, textAlign: 'center' }}>
        <Typography variant="body2">
          DeskStudio © 2026
        </Typography>
      </Box>

    </LandingPageLayoutMobile>
  );
}
